/* Change this file to get your Personal Portfolio */

import emoji from "react-easy-emoji";

// Summary And Greeting Section

const greeting = {
  username: "Maximilian Georg",
  title: "Hi all, I'm Max",
  subTitle: emoji(
    "A passionate Engineering Leader with 5+ years of experience building and shipping products with real customer value. I love to build fast, learn, iterate, and lead teams to success!"
  ),
  resumeLink: "", // Add your resume link here
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Your Social Media Link

const socialMediaLinks = {
  github: "https://github.com/maxgeorg99",
  linkedin: "https://www.linkedin.com/in/maximilian-georg-73354a18a",
  instagram: "https://www.instagram.com/maxigeorg99/",
  gmail: "maxi.georg.mg@gmail.com",
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle:
    "PASSIONATE SENIOR SOFTWARE ENGINEER WHO LOVES TO EXPLORE AND BUILD WITH CUTTING-EDGE TECHNOLOGIES",
  skills: [
    emoji(
      "⚡ Develop robust backend systems using Java/Spring and modern architecture patterns"
    ),
    emoji("⚡ Lead technical teams and mentor junior developers"),
    emoji("⚡ Design and implement Domain-Driven Design (DDD) architectures"),
    emoji(
      "⚡ Advocate for best practices and guide product decisions in cross-functional scrum teams"
    ),
    emoji(
      "⚡ Handle go lives and take full responsibility for production releases"
    ),
    emoji(
      "⚡ Build interactive and responsive frontend applications with Vue.js"
    ),
    emoji("⚡ Build cross-platform mobile applications using Flutter/Dart"),
    emoji(
      "⚡ Implement data pipelines and machine learning solutions with Python"
    ),
    emoji(
      "⚡ Create multiplayer games and real-time applications using SpacetimeDB"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "Java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "Spring Framework",
      fontAwesomeClassname: "fas fa-leaf"
    },
    {
      skillName: "Vue.js",
      fontAwesomeClassname: "fab fa-vuejs"
    },
    {
      skillName: "JavaScript/TypeScript",
      fontAwesomeClassname: "fab fa-js-square"
    },

    {
      skillName: "Python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "Rust",
      fontAwesomeClassname: "fab fa-rust"
    },
    {
      skillName: "AWS",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "Git",
      fontAwesomeClassname: "fab fa-git-alt"
    },
    {
      skillName: "Docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Karlsruhe Institute of Technology (KIT)",
      logo: require("./assets/images/kit-logo.png"), // Add KIT logo to assets/images/
      subHeader: "Bachelor of Science in Computer Science",
      duration: "2020 - 2022",
      desc: "Graduated with Bachelor's degree in Computer Science. Thesis: Data Sparing Dependency Estimation",
      descBullets: [
        "Specialized in software engineering and data analysis",
        "Bachelor thesis on advanced data dependency estimation algorithms"
      ]
    },
    {
      schoolName: "ETH Zürich",
      logo: require("./assets/images/ETH-Logo.png"), // Add ETH logo to assets/images/
      subHeader: "Computer Science Studies",
      duration: "2018 - 2020",
      desc: "Started Computer Science studies at one of Europe's top technical universities",
      descBullets: [
        "Strong foundation in computer science fundamentals",
        "Transferred to KIT to complete degree"
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Backend Development (Java/Spring)", //Insert stack or technology you have experience in
      progressPercentage: "95%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Technical Leadership & Mentoring", //Insert stack or technology you have experience in
      progressPercentage: "95%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Domain-Driven Design (DDD)",
      progressPercentage: "90%"
    },
    {
      Stack: "Database Design & SQL",
      progressPercentage: "90%"
    },
    {
      Stack: "Frontend Development (Vue.js)",
      progressPercentage: "75%"
    },
    {
      Stack: "Python/Data Analysis",
      progressPercentage: "75%"
    },
    {
      Stack: "Flutter/Mobile Development",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to false to hide workExperiences section, defaults to true
  experience: [
    {
      role: "Team Lead Development",
      company: "Chrono24",
      companylogo: require("./assets/images/chrono24-logo.png"), // Add company logo
      companylogoSmall: require("./assets/images/chrono24-logo-small.png"),
      date: "August 2026 – Present",
      desc: "Leading a 2 Scrum teams with up to 8 Developers with a focus on delivering high-quality, software solutions for all seller centric products.",
      descBullets: [
        "Technical Owner for seller facing products",
        "Lead team guidance and mentorship, taking technical decisions and shaping product direction",
        "Conducted end-to-end recruiting and technical interviews for new developer roles"
      ]
    },
    {
      role: "Senior Software Engineer",
      company: "Chrono24",
      companylogo: require("./assets/images/chrono24-logo.png"), // Add company logo
      companylogoSmall: require("./assets/images/chrono24-logo-small.png"),
      date: "June 2023 – July 2026",
      desc: "Backend development, Domain owner (DDD) for Registration + Shipping + Certification. ",
      descBullets: [
        "Technical Owner for 'Certified' program - company-wide technical point of contact for authentication system",
        "Lead team guidance and mentorship, speaking up on technical decisions and product direction",
        "Conducted end-to-end recruiting and technical interviews for Senior Java Developer roles",
        "Handle critical live deployments and take full responsibility for production issues across the organization",
        "Developed premium upgrade payment system with PayPal integration for private sellers",
        "Handle critical live deployments and take full responsibility for production issues across the organization"
      ]
    },
    {
      role: "Software Engineer",
      company: "Chrono24",
      companylogo: require("./assets/images/chrono24-logo.png"),
      companylogoSmall: require("./assets/images/chrono24-logo-small.png"),
      date: "October 2022 – June 2023",
      desc: "One of two backend developers in a 7-person Scrum team, taking on diverse responsibilities and demonstrating leadership qualities.",
      descBullets: [
        "Handled full-stack development: concept design, data management, process development, API provision",
        "Developed features for marketplace seller side (both dealers and private sellers) in 'Supply' product area",
        "Moderated Daily Scrums and led product presentations inside and outside of reviews",
        "Gained recognition for technical problem-solving and proactive communication",
        "Began mentoring new team members and taking initiative on critical issues"
      ]
    },
    {
      role: "Working Student - Java Developer",
      company: "Chrono24",
      companylogo: require("./assets/images/chrono24-logo.png"),
      companylogoSmall: require("./assets/images/chrono24-logo-small.png"),
      date: "April 2020 – October 2022",
      desc: "Started as working student while completing Bachelor's degree, quickly demonstrating exceptional potential and technical skills.",
      descBullets: [
        "Contributed to core marketplace functionality and backend services",
        "Gained expertise in Java/Spring ecosystem and Vue.js frontend development",
        "Participated in agile development processes and code reviews",
        "Built foundation in domain-driven design principles"
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle:
    "MAJOR PROJECTS THAT SHOWCASE MY EXPERTISE IN BUILDING SCALABLE SOLUTIONS",
  projects: [
    {
      image: require("./assets/images/certification.png"),
      projectName: "Watch Certification System",
      projectDesc:
        "Built end-to-end certification process from scratch enabling authenticated watch verification between sellers and buyers through professional watchmakers. Achieved product-market fit through iterative development from smoke tests to MVP to V1. See the LinkedIn post for a visual and product journey!",
      footerLink: [
        {
          name: "LinkedIn Post",
          url: "https://www.linkedin.com/posts/jan-schuhmacher-head-of-product-management-chrono24_%F0%9D%97%96%F0%9D%97%B2%F0%9D%97%BF%F0%9D%98%81%F0%9D%97%B6%F0%9D%97%B3%F0%9D%97%B6%F0%9D%97%B2%F0%9D%97%B1-%F0%9D%97%AF%F0%9D%98%86-%F0%9D%97%96%F0%9D%97%B5%F0%9D%97%BF%F0%9D%97%BC%F0%9D%97%BB%F0%9D%97%BC%F0%9D%9F%AE-activity-7183422573307645952-cCSu?utm_source=share&utm_medium=member_desktop&rcm=ACoAACyTJ5cBNcsVttK6b7-jZfq_PJnlNrxcsA8"
        }
      ]
    },
    {
      image: require("./assets/images/private-seller-funnel.png"),
      projectName: "Private Seller Funnel Rebuild",
      projectDesc:
        "Completely rebuilt legacy seller onboarding system as modern Vue.js SPA with auto-generated TypeScript models, Jakarta validation, premium options, and PayPal integration. Dramatically improved user experience and conversion rates. See the LinkedIn post for a visual and product journey!",
      footerLink: [
        {
          name: "LinkedIn Post",
          url: "https://www.linkedin.com/posts/j%C3%B6rg-mascha-32557a188_private-seller-our-next-app-first-feature-activity-7234487488222810113-LvRH/?utm_source=share&utm_medium=member_desktop&rcm=ACoAACyTJ5cBNcsVttK6b7-jZfq_PJnlNrxcsA8"
        }
      ]
    },
    {
      image: require("./assets/images/offer-negotiation.jpeg"),
      projectName: "New Price Negotiation Funnel",
      projectDesc:
        "Completely rebuilt how buyer and seller negotiate prices and come to a product which empowers users in their process while keeping the preferences and wishes of buyers and sellers in mind. We used the insights from many customer interviews and Domain-driven design to improve the user experience and conversion rates while establishing a solid technical foundation."
    },
    {
      image: require("./assets/images/personalized-offers.png"),
      projectName: "Personalized Offers for Prospective Buyers",
      projectDesc:
        "Shipped a targeted offer feature with my team allowing dealers to send personalized discounts to users who saved their watch on the Wishlist. Delivered in a short timeframe with zero bugs, generating a 5%+ uplift in sales on the marketplace."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements 🏆 "),
  subtitle: "CAREER MILESTONES AND PROFESSIONAL GROWTH",
  achievementsCards: [
    {
      title: "Technical Leadership Excellence",
      subtitle:
        "Natural technical leader guiding teams, handling critical deployments, and taking full responsibility for production issues across the organization",
      image:
        "https://informationage-production.s3.amazonaws.com/uploads/2022/10/information-ages-guide-to-tech-leadership-roles.jpeg", // Stock image: leadership
      footerLink: []
    },
    {
      title: "Rapid Career Progression",
      subtitle:
        "Promoted all the way from Working Student → Junior- → Intermediate- → Senior Engineer → Team Lead in just 3 years, with exceptional performance at each level",
      image:
        "https://media.istockphoto.com/id/2168908844/de/foto/exzellenz-wachstumsstrategie-gesch%C3%A4ftstrendkonzept-gesch%C3%A4ftsmann-hand-auf-pfeil-investieren.jpg?s=612x612&w=0&k=20&c=wq28a6OzZ1WGAE5ymc3iKHKlmPe-VfZXQSoGWFwXGG0=", // Stock image: career growth
      footerLink: []
    },
    {
      title: "Mentorship & Team Development",
      subtitle:
        "Active mentor, guiding multiple new hires and supporting their integration into the company",
      image:
        "https://images.unsplash.com/photo-1503676382389-4809596d5290?auto=format&fit=crop&w=400&q=80", // Stock image: mentorship
      footerLink: []
    },
    {
      title: "Critical Systems Ownership",
      subtitle:
        "Trusted with most go lives of big project and critical issues, serving as Technical Owner for company-wide tech topics",
      image:
        "https://images.unsplash.com/photo-1461749280684-dccba630e2f6?auto=format&fit=crop&w=400&q=80", // Stock image: critical systems
      footerLink: []
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Latest Blog Posts",
  subtitle:
    "SHARING MY JOURNEY, INSIGHTS, AND LESSONS LEARNED IN SOFTWARE ENGINEERING AND GAME DEVELOPMENT",
  displayMediumBlogs: "false", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      id: "move-to-omarchy",
      title: "My Move to Omarchy",
      description:
        "A reflection on my decision to embrace omarchy and what it means for my journey as a software engineer and leader."
    },
    {
      id: "game-engine-comparison",
      title: "Game Engine Comparison:\nFinding the Right Tool for Your Project",
      description:
        "An in-depth comparison of modern game engines including Unity, Unreal, Godot, and SpacetimeDB for multiplayer games."
    },
    {
      id: "vampire-survivor-game",
      title: "My First Multiplayer Game",
      description:
        "An in-depth look at the development process of my first game."
    },
    {
      id: "jpa-comparison",
      title: "JPA Comparison",
      description:
        "An in-depth comparison of modern Java Persistence APIs including Hibernate, EclipseLink, and Spring Data JPA."
    },
    {
      id: "server-side-rendering-comparison",
      title: "Server-Side Rendering:\nWhy It Still Matters",
      description:
        "A comprehensive comparison of Java templating engines and why its still relevant."
    },
    {
      id: "multiplatform-frameworks-comparison",
      title: "Cross-Platform Mobile Development:\nChoosing the Right Framework",
      description:
        "A comprehensive comparison for cross-platform mobile development."
    },
    {
      id: "rust-stack",
      title: "Becoming a Rustacean",
      description:
        "My current Rust stack and experience with the Rust toolchain."
    },
    {
      id: "game-dev-journey",
      title: "My Game Dev Journey:\n4 Games in One Year",
      description:
        "My journey from zero game dev experience to developing games across different engines: SpacetimeDB, LÖVE2D, Bevy, and Godot."
    },
    {
      id: "wasm-bevy-spacetimedb",
      title: "Bevy in the Browser:\nWASM and SpacetimeDB",
      description:
        "A deep dive into how WebAssembly enables running Rust games in browsers and why the WASM-native stack beats traditional web architecture."
    },
    {
      id: "tiny-tactics-dev-log",
      title: "Tiny Tactics - RTS x TD Dev Log",
      date: "2026-02-21",
      description:
        "Update on my Game and new things I learned in game development."
    },
    {
      id: "spacetimedb-benchmarks",
      title:
        "The State of Cutting-Edge Web Backends:\n300k TPS, Zero Infrastructure",
      description: "Exploring the frontier of web development"
    },
    {
      id: "solo-dev-jam-11",
      title: "My First Game Jam:\nSolo Dev Jam 11",
      description:
        "I entered my first game jam with Pay in Blood and placed 48th out of 212 submissions."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    // Add your talks here if you have any
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    // Add podcast links here if you have any
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+49 152 52866559",
  email_address: "maxi.georg.mg@gmail.com"
};

// Twitter Details

const twitterDetails = {
  userName: "twitter", // Replace with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Placeholder value for isHireable
const resumeSection = {resumeLink: ""}; // Placeholder for resumeSection
const splashScreen = {display: true}; // Placeholder for splashScreen
const illustration = {animated: true}; // Placeholder for illustration

export {
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection,
  splashScreen,
  illustration
};
